import React, { Component } from "react";
import RouteMenu from "VENDOR/CommonResources/RoutingMenu/RouteMenu";
import "../VendorQuotation/VendorQuotation.scss";
import print from "../../CommonResources/print.png";
import expo from "../../CommonResources/export.png";
import { connect } from "react-redux";
import invoiceB from "../../CommonResources/invoiceB.png";
import status from "../../CommonResources/status.png";
import requested from "../../CommonResources/requested.png";
import expected from "../../CommonResources/expected.png";
import { ToastContainer, toast } from "react-toastify";
import insititute from "../../CommonResources/insititute.png";
import config from "config";
import vendorApiCall from "vendorApiCall";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ButtonLoader from "VENDOR/CommonResources/ButtonLoader/ButtonLoader";
import ExportJsonButton from "VENDOR/CommonResources/export/ExportExcelButton";
import Pagination from "react-js-pagination";
import ViewPO from "./ViewPO";
import * as XLSX from "xlsx";
import ReactToPrint from "react-to-print";


let apiPath = "/vendor/api/vendor.php";
const pageStyle = `
  @media print {
    @page {
      size: landscape;
      margin: 0.5cm;
    }

    body {
      font-size: 12px;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }

    table {
      width: 100%;
      border-collapse: collapse;
    }

    th, td {
      border: 1px solid #000;
      padding: 4px;
      text-align: left;
    }

    tr {
      page-break-inside: avoid;
    }

    .hidden-export-row {
      display: table-row !important;
    }

    input, select, button {
      display: none !important;
    }

    .icon-button, .pagination, .btn-submit, .btn-cancel, .quotation-input {
      display: none !important;
    }
  }
`;

const mockIsPOFetching = false;
class VendorPO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableData: [],
      filterText: "",
      statusFilter: localStorage.getItem("purchase-order_filter") || "",
      showModal: false,
      selectedRow: null,
      modalTableData: [],
      isLoading: false,
      activePage: 1,
      itemsPerPage: 10,
      totalItemsCount: 0,
      isPOFetching: false,
      POData: [],
      viewPOModal: false,
      purchaseOrder: '',
      selectedVendorId:'',
      selectedInstitute:'',
      iidArray:this.props.iidArray,
      exportDetails:false,
      expectedDate:""

    };
  }

  componentDidMount() {
    this.fetchPO();
    localStorage.setItem(`purchase-order_filter`,"");

  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(this.props.iidArray) != JSON.stringify(prevProps.iidArray)
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
        },
        () => {
          this.fetchPO();
        }
      );
    }
    if (
      JSON.stringify(this.props.iidDetails) != JSON.stringify(prevProps.iidDetails)
    ) {
      this.setState(
        {
          iidArray: this.props.iidArray,
        },
        () => {
          this.fetchPO();
        }
      );
    }
  }

  fetchPO = async () => {
    this.setState({ isLoading: true, tableData:[] });

    const offset = (this.state.activePage - 1) * this.state.itemsPerPage;
    const vendorArray = Object.keys(this.props.iidDetails).map(iid => {
      const details = this.props.iidDetails[iid]?.details;
      return details?.vendorId || null;
    }).filter(Boolean);
    const requestData = {
      iidArray: this.state.iidArray,
      vendorIdArray: vendorArray,
      status: this.state.statusFilter,
      filterText: this.state.filterText,
      limit: this.state.itemsPerPage, 
      offset,
    };

    let jsonResponse = await vendorApiCall.makeApiCall(
      "inventory_getPurchaseOrdersByVendor",
      requestData,
      apiPath
    );
    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      const rawData = response.data;

      const formattedData = Object.keys(rawData).reverse().map((key, index) => {
        const item = rawData[key];

        return {
          srNo: ((this.state.activePage - 1) * this.state.itemsPerPage) + index + 1,
          poNumber: item.poNumber,
          instituteName: item.instituteName,
          requestedBy: item.requestedByName,
          requestedOn: item.requestedOn,
          poId:item.poId,
          prId:item.pr_uid,
          countDown: this.calculateCountdown(item.expectedOn),
          poStatus: item.poStatus,
          action: item.status === "Pending" ? "view PO " : "view PO",
          iid: item.iid,
          prVendorId: item.prVendorId,
          prDetails:item.prDetails,
          vendorId:item.vendorId,
          prName:item.prName,
          prNumber:item.prNumber,

        };
      });

      this.setState({ tableData: formattedData, totalItemsCount: response.totalCount });
    }
    this.setState({ isLoading: false });
  };

  calculateCountdown = (expectedDate) => {
    const currentDate = new Date();
    const targetDate = new Date(expectedDate);

    const differenceInMs = targetDate - currentDate;
    const differenceInDays = Math.ceil(differenceInMs / (1000 * 60 * 60 * 24));

    if (differenceInDays < 0) {
      return "Expired";
    } else if (differenceInDays === 0) {
      return "Today";
    } else {
      return `Within ${differenceInDays} Days`;
    }
  };

  handleFilterChange = (e) => {
        
        this.setState({ filterText: e.target.value, activePage: 1, offset:0 }, this.fetchPO);
  };
  

  handleInstituteChange = (e) => {
    const selected = e.target.value;

    let updatedArray = selected === "" ? this.props.iidArray : [selected];

    this.setState(
      {
        selectedInstitute: selected,
        iidArray: updatedArray,
        offset:0,
        activePage: 1,
      },
      () => {
        this.fetchPO();
      }
    );
  };
  handleStatusChange = (e) => {
    this.setState({ statusFilter: e.target.value, activePage: 1, offset:0 }, this.fetchPO);
  };

  handlePageChange = (pageNumber) => {
    this.setState({ activePage: pageNumber }, this.fetchPO);
  };

  handlePrint = () => {
        const originalContents = document.body.innerHTML;
        const modalContents = document.querySelector(".modalDataContainer").innerHTML;
    
        document.body.innerHTML = modalContents;
        window.print();
        document.body.innerHTML = originalContents;
        window.location.reload(); 
      };


  formatDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    if (isNaN(date)) {
      return "Invalid Date";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  openFillQuotationModal = async (row) => {
    this.setState({
      showModal: true,
      selectedRow: row,
      modalTableData: [],
      isLoading: true,
      quotationNumber: "",
    });
    
    const requestData = {
      vendorId: row.vendorId,
      prVendorId: row.prVendorId,
      po:"yes"
    };

    if(row.poStatus == 'approve'){

    }
    let jsonResponse = await vendorApiCall.makeApiCall(
      "inventory_getQuotationDetailsRecivedToVendors",
      requestData,
      apiPath
    );

    const response = jsonResponse?.APIResult || {};

    if (response.success === "true") {
      const modalData = Object.values(response.data).map((item, index) => ({
        srNo: index + 1,
        ...item,
      }));

      this.setState({
        modalTableData: modalData,
        quotationNumber: response.quotationNumber,
        expectedDate:response.expectedDate
      });
    }
    this.setState({ isLoading: false });
  };

  closeModal = () => {
    this.setState({ showModal: false, selectedRow: null, modalTableData: [] });
  };

  handleInputChange = (e, rowId, field) => {
    const value = e.target.value;

    this.setState((prevState) => {
      const updatedModalTableData = prevState.modalTableData.map((row) => {
        if (row.uniqueId === rowId) {
          const updatedRow = { ...row, [field]: value };

          const amount = parseFloat(updatedRow.amountPerUnit) || 0;
          const discount = parseFloat(updatedRow.discount) || 0;
          const tax = parseFloat(updatedRow.tax) || 0;

          const discountedAmount = amount - (amount * discount) / 100;
          updatedRow.applicableAmount =
            discountedAmount + (discountedAmount * tax) / 100;

          return updatedRow;
        }
        return row;
      });

      return { modalTableData: updatedModalTableData };
    });
  };

  handleModalSubmit = (actionType) => {
    const { modalTableData, quotationNumber, selectedRow } = this.state;

    const quotation = modalTableData.reduce((acc, row) => {
      acc[row.uniqueId] = {
        amountPerUnit: row.amountPerUnit || 0,
        applicableAmount: row.applicableAmount || 0,
        taxApplicable: row.tax || 0,
        discount: row.discount || 0,
        uniqueId: row.uniqueId,
      };
      return acc;
    }, {});

    const requestData = {
      iid: selectedRow.iid,
      vendorId: selectedRow.vendorId,
      poId: selectedRow.poId,
      status: actionType,
    };
    
    // {"iid":113, "vendorId":74, "poId":28,"status":"approve"}
    vendorApiCall
      .makeApiCall("inventory_changePoStatus", requestData, apiPath)
      .then((response) => {
        if (response?.APIResult?.message) {
          toast.success(`You have successfully ${actionType == 'accept' ? "Accepted" : "Rejected "} PO.`);
          this.fetchPO();
          
        } else {
          toast.error("Unexpected response format");
          this.fetchPO();
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        toast.error(error.message || "An error occurred while processing the request");
      });
    this.setState({showModal:false});
  };

  viewPurchaseOrder = (purchaseOrder) => {
    this.setState({
        viewPOModal: true,
        purchaseOrder: purchaseOrder
    });

  }

  closeViewPOModal = () => {
    this.setState({
        viewPOModal: false,
        purchaseOrder: ''
    });
}

getInstituteLogoByIid = (iid )=>{
  return this.props.iidDetails[iid].details.logo1;  
}

  renderModal = () => {
    const { showModal, modalTableData, isLoading, quotationNumber } =
      this.state;
    const TAX_OPTIONS = [5, 12, 18, 28];

    if (!showModal) return null;

    return (
      <div className="quotation-modal">
        <div className="quotation-modal-content">
          {/* Modal Header */}
          <div className="modal-header"  style={{
                  color: "#202020",
                  background: "white",
                  border: "none",
                  cursor: "pointer",
                }} >
            <h3>Accept or Reject Purchase Order </h3>
            <div>
              <button aria-label="Print" className="icon-button"  onClick={this.handlePrint}>
                <img src={print} alt="Print Icon" />
              </button>
              <ExportJsonButton data={modalTableData} />
             
             
                <FontAwesomeIcon icon={["fas", "times"]}  onClick={this.closeModal} />
             
            </div>
          </div>
          {/* Modal Body */}
          <div className="modal-body">
            {isLoading ? (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <ButtonLoader />
                <span>Loading...</span>
              </div>
            ) : (
              <>
                {/* Header Section */}
                {/* <div
                  className="heading mb-3"
                  style={{ display: "flex", flexDirection: "row" }}
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ minHeight: "15px" }}></div>
                  </div>
                </div>
                <div className="separator"></div> */}

                {/* Information Section */}
                <div className="info-bar">
                  {/* <div className="info-left" style={{ display: "flex" }}>
                    <div className="icon-circle">
                      <img src={invoiceB} alt="Icon" />
                    </div>
                    <div>
                      <p className="small-text">Purchase Request Details</p>
                      <h6 className="bold-text"></h6>
                    </div>
                  </div> */}

                    <div className="info-right">
                      <div className="info-block">
                        <div className="icon-circle">
                          <img
                            src={this.getInstituteLogoByIid(this.state.selectedRow.iid)}
                            alt="Institute name"
                            style={{
                              height:'25px',
                              width:'25px',
                              borderRadius:'50%'
                            }}

                          />
                        </div>
                        <div>
                          <p className="small-text">Institute name</p>
                          <p className="bold-text">{this.state.selectedRow.instituteName}</p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={invoiceB} alt="Purchase Request Details" />
                        </div>
                        <div>
                          <p className="small-text">Purchase Request Details</p>
                          <p
                              className="bold-text"
                              title={this.state.selectedRow.prNumber + this.state.selectedRow.prName}
                            >
                              {(
                                this.state.selectedRow.prNumber + this.state.selectedRow.prName
                              ).length > 25
                                ? (this.state.selectedRow.prNumber + this.state.selectedRow.prName).substring(0, 25) + "..."
                                : this.state.selectedRow.prNumber + this.state.selectedRow.prName}
                            </p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={requested} alt="Requested On" />
                        </div>
                        <div>
                          <p className="small-text">Requested On</p>
                          <p className="bold-text">{this.formatDate(this.state.selectedRow.requestedOn)}</p>
                        </div>
                      </div>

                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={expected} alt="Expected On" />
                        </div>
                        <div>
                          <p className="small-text">Expected On</p>
                          <p className="bold-text">{this.formatDate(this.state.expectedDate)}</p>
                        </div>
                      </div>
                      <div className="info-block">
                        <div className="icon-circle">
                          <img src={status} alt="Current Status" />
                        </div>
                        <div>
                          <p className="small-text">Current Status</p>
                          
                           <p className={`status ${this.state.selectedRow.poStatus.toLowerCase()} mb-0`} >
                        
                            {this.state.selectedRow.poStatus === 'approve' 
                            ? 'Approved' 
                            : this.state.selectedRow.poStatus === 'accept' 
                            ? 'Accepted' 
                            : this.state.selectedRow.poStatus === 'cancel' 
                            ? 'Cancelled' 
                            : this.state.selectedRow.poStatus === 'rejected'
                            ? 'Rejected' 
                            : this.state.selectedRow.poStatus}
                            </p>
                        </div>
                      </div>
                    </div>
                </div>
                <table className="quotation-table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Asset Name</th>
                      <th>Asset Type</th>
                      <th>Expected Quantity</th>
                      <th>Applicable Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalTableData.map((row) => (
                      <tr key={row.uniqueId}>
                        <td>{row.srNo}</td>
                        <td>{row.catalogueName || "N/A"}</td>
                        <td>{row.catalogueType || "N/A"}</td>
                        <td>{row.expectedQuantity || "N/A"}</td>
                        <td className="applicable-amount">
                          {parseFloat(row.applicableAmount.toFixed(4)) || 0}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>

          {/* Modal Footer */}
          <div className="modal-footer" style={{ justifyContent: "flex-end" }}>
          <p>
          {this.state.selectedRow.poStatus === "Generated"
            ? "You can accept or reject PO once it is approved by the institute's accounting department."
            : ""}
          </p>
            <button
              className="btn "
              onClick={() => this.handleModalSubmit("rejected")}
              style={{background:'#FCEAE8', color:'#FF0800'}}
              disabled={this.state.selectedRow.poStatus !== 'approve'}
            >
              Reject
            </button>

            <button
              className="btn"
              onClick={() => this.handleModalSubmit("accept")}
              style={{background:'#369933', color:'white'}}
              disabled={this.state.selectedRow.poStatus !== 'approve'}
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    );
  };

   
     exportRenderedTableToExcel = () => {
       const originalTable = this.tableRef;
     
       if (!originalTable) {
         toast.error("Table not found.");
         return;
       }
     
   
       const clonedTable = originalTable.cloneNode(true);
     
       const hiddenRows = clonedTable.querySelectorAll(".hidden-export-row");
       hiddenRows.forEach((row) => {
         row.style.display = "table-row";
       });
     
   
       clonedTable.style.position = "absolute";
       clonedTable.style.left = "-9999px";
       document.body.appendChild(clonedTable);
     
       const wb = XLSX.utils.table_to_book(clonedTable, { sheet: "Quotations" });
       XLSX.writeFile(wb, "Purchase orders.xlsx");
     
       document.body.removeChild(clonedTable);
     };
     
  
    handleExport = () => {
      this.setState({exportDetails:true}, ()=> {this.exportRenderedTableToExcel(); this.setState({exportDetails:false}) });
    };

     handlePrint = () => {
            const originalContents = document.body.innerHTML;
            const modalContents = document.querySelector(
              ".modalDataContainer"
            ).innerHTML;
      
            document.body.innerHTML = modalContents;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload();
          };
  render() {
    const { isLoading } = this.state;
    const statusOptions = [
      { value: "accept", label: "Accepted" },
      { value: "Generated", label: "Generated" },
      { value: "cancel", label: "Cancelled" },
      { value: "rejected", label: "Rejected" },
      { value: "approve", label: "Approved" },
    ];
    return (
      <div>
        <RouteMenu />
        <div className="modalDataContainer">
        <div className="quotation-main">
          <div className="quotation-header">
            Purchase Orders
            <p style={{ fontSize: "12px" }}>
              Once a purchase order Requested by Organisation you can decline or
              approve by proceed the order request.
            </p>
          </div>
          <div
            className="seprator"
            style={{
              borderBottom: "1px solid #AAAAAA",
              height: "3px",
              width: "100%",
              marginBottom: "15px",
            }}
          ></div>
          <div className="quotation-filter">
            <div className="filters">
              <input
                type="text"
                placeholder="Search "
                value={this.state.filterText}
                onChange={this.handleFilterChange}
              />
               <select
                onChange={this.handleInstituteChange}
                value={this.state.selectedInstitute}
              >
                <option value="">All Institute</option>
                {Object.entries(this.props.iidDetails).map(([key, value]) => (
                  <option key={key} value={key}>
                    {value.details.instituteName}
                  </option>
                ))}
              </select>

              <select
                onChange={this.handleStatusChange}
                value={this.state.statusFilter}
              >
                <option value="">All Status</option>
                <option value="Generated">Generated</option>
                <option value="approve">Approved</option>
                <option value="cancel">Cancelled</option>
                <option value="accept">Accepted</option>
                <option value="reject">Rejected</option>
              </select>
            </div>
            <div>
              <ReactToPrint
                trigger={() => 
                  <button  className="icon-button">
                    <img src={print} alt="Print Icon"   />
                   
                  </button>
                }
                pageStyle={pageStyle}
                content={() => this.tableRef}
                />
              <button
                aria-label="Print"
                className="icon-button"
                onClick={this.handleExport}
                title="Click here to export the entries to excel file"

              >
                <img src={expo} alt="Export" />
              </button>
             
            </div>
          </div>
          <div  className="clear-filters">
          <p>{(this.state.filterText !== "" || this.state.statusFilter !==  "" || this.state.selectedInstitute !=="") ? "Filters are applied.": ""}</p>
          
          <div
            style={{
              color:'#007bff',
              cursor:'pointer'
            }}
            onClick={() =>
              this.setState(
                { filterText: "", statusFilter: "" , selectedInstitute:"", iidArray:this.props.iidArray,  activePage: 1, offset:0 },
                this.fetchPO
              )
            }
          >
            <u>Clear All</u>
          </div>
        </div>
         
          <div className="table-scroll-container ">
            <table  ref={(ref) => (this.tableRef = ref)} className="quotation-table">
              <thead>
              <tr
                    className="hidden-export-row"
                   
                  >
                    <th colSpan="10" >
                        <p style={{
                          display:"flex",
                          justifyContent:"center",
                          textAlign: "center",
                          verticalAlign: "middle",
                          fontWeight: "bold",
                          fontSize: "16px",
                          
                        }}>Purchase Orders</p>
                    </th>
                </tr>

                  {(this.state.filterText || this.state.statusFilter || this.state.selectedInstitute ) && (
                    <tr className="hidden-export-row">
                      <th colSpan="10">
                        {this.state.filterText &&
                          `PO Number: ${this.state.filterText}`}
                        {this.state.statusFilter &&
                            ` | Status: ${ statusOptions.find(opt => opt.value === this.state.statusFilter)?.label}`}
                          {this.state.selectedInstitute &&
                          ` | Institute: ${this.props.iidDetails[this.state.selectedInstitute].details.instituteName}`}
                      </th>
                    </tr>
                  )}
                <tr>
                  <th>Sr. No.</th>

                  <th>PO Number</th>
                  <th>Institute Name</th>
                  <th>Requested By</th>
                  <th>Requested On</th>
                  {/* <th>Expected On</th> */}
                  {/* <th>Count Down</th> */}
                  <th>Status</th>
                  {!this.state.exportDetails ?  <th  className="hidePrint">Action</th> : <></> }
                 
                </tr>
              </thead>
              <tbody>
                {this.state.tableData.length > 0 ? (
                  this.state.tableData.map((row, index) => (
                    <tr key={index}>
                      <td>{row.srNo}</td>
                      <td>{row.poNumber}</td>
                      <td>{row.instituteName}</td>
                      <td>{row.requestedBy}</td>
                      <td>{this.formatDate(row.requestedOn)}</td>
                      <td className={`status ${row.poStatus.toLowerCase()}`}>
                        
                      {row.poStatus === 'approve' 
                      ? 'Approved' 
                      : row.poStatus === 'accept' 
                      ? 'Accepted' 
                      : row.poStatus === 'cancel' 
                      ? 'Cancelled' 
                      : row.poStatus === 'rejected'
                      ? 'Rejected' 
                      : row.poStatus}
                      </td>

                  {!this.state.exportDetails ? 

                      <td
                         className="action hidePrint"
                        style={{ cursor: "pointer" }}
                      >
                       {row.poStatus === 'accept' ? (
                        <span
                          className="download-po-btn"
                          onClick={() => this.viewPurchaseOrder(row)}
                        >
                          Download PO
                        </span>
                      ) : (
                        <span onClick={() => this.openFillQuotationModal(row)} >
                          {row.action}
                        </span>
                      )}
                      </td>
                       : <></> }
                    </tr>

                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="10"
                      style={{ textAlign: "center", fontStyle: "italic" }}
                    >
                    
                      {isLoading ? (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <ButtonLoader />
                            <span style={{ marginLeft: "10px" }}>Loading...</span>
                          </div>
                        ): <p>{(this.state.filterText !== "" || this.state.statusFilter !==  "" || this.state.selectedInstitute !=="") ? "No purchase order available as per applied filters.": "No purchase order available."}</p>}

                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
         

                        {
                            this.state.totalItemsCount  > 0 &&
                            <div className="" style={{ marginTop: '2%' }}>
                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15, marginTop: "1rem" }}>
                                    <div ref={this.dropdownRef} className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold",  }}>

                                        <select
                                            className={`dropdown ${this.state.dropdownDirection}`}
                                            value={this.state.itemsPerPage}
                                            onChange={(e) =>
                                              this.setState(
                                                {
                                                  itemsPerPage: parseInt(e.target.value, 10),
                                                  activePage: 1,
                                                },
                                                this.fetchPO
                                              )
                                            }
                                        >
                                            <option value={10} className='entryFont'>Entries Per Page 10</option>
                                            <option value={25} className='entryFont'>Entries Per Page 25</option>
                                            <option value={40} className='entryFont'>Entries Per Page 40</option>
                                            <option value={100} className='entryFont'>Entries Per Page 100</option>
                                            <option value={250} className='entryFont'>Entries Per Page 250</option>
                                        </select>

                                    </div>

                                    {
                                       
                                        <div className="pagignation">
                                            <Pagination
                                                itemsCountPerPage={this.state.itemsPerPage}
                                                totalItemsCount={this.state.totalItemsCount}
                                                pageRangeDisplayed={5}
                                                onChange={this.handlePageChange}
                                                itemClass="page-item"
                                                linkClass="page-link"
                                                activeClass="active"
                                                prevPageText="‹"
                                                nextPageText="›"
                                                firstPageText="«"
                                                lastPageText="»"
                                                activePage = {this.state.activePage}

                                            />
                                            
                                        </div>
                                    }

                                    <p className="" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalItemsCount} </p>
                                </div>
                            </div>
                        }

          <ToastContainer theme="light" />
        </div>
        </div>
        {this.renderModal()}

        {this.state.viewPOModal &&
                                <ViewPO
                                    viewModal={this.state.viewPOModal}
                                    purchaseOrder={this.state.purchaseOrder}
                                    currentDesign={this.state.currentDesign}
                                    isPOFetching={this.state.isPOFetching}
                                    closePOModal={this.closeViewPOModal}
                                />
                        }
      </div>
    );
  }
}
const mapStateToProps = (store) => ({
  iidArray: store.RouteMenuReducer.assignedIIDArray,
  iidDetails: store.RouteMenuReducer.assignedIIDDetails,
});

export default connect(mapStateToProps)(VendorPO);
